<app-modal
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  (onHidden)="onHiddenInternal()"
  [closeOutsideClickEnabled]="false"
  modalTitle="Gravar"
  width="25rem"
  height="13rem"
>
  <ng-template modalContent>
    <form class="form" [formGroup]="formGroup" (ngSubmit)="onSubmit($event)">
      <div class="fields-container">
        <div class="field-set">
          <label label>Nome da Pesquisa*</label>

          <app-input-box
            formControlName="name"
            [autocomplete]="false"
            [showErrorEnabled]="false"
          ></app-input-box>
        </div>
      </div>

      <div class="actions-bottom">
        <app-button
          type="submit"
          buttonType="primary"
          styleType="contained"
          text="Gravar"
          width="100%"
        ></app-button>

        <app-button
          buttonType="normal"
          styleType="contained"
          text="Cancelar"
          (click)="onBtnCancelClick()"
          width="100%"
        ></app-button>
      </div>
    </form>
  </ng-template>
</app-modal>
